import classNames from 'classnames';
import React from 'react';
import './grid.scss';

type ContainerProps = {
  children: React.ReactNode;
  fluid?: boolean;
  className?: string;
};

export const Container = ({ children, fluid, className }: ContainerProps) => (
  <div
    className={classNames(fluid ? 'container-fluid' : 'container', className)}
  >
    {children}
  </div>
);
type RowProps = {
  children: React.ReactNode;
  rowGap?: string | number;
  columnGap?: string | number;
  mobileColumnGap?: string | number;
  className?: string;
};

const formatGap = (gap?: string | number) =>
  typeof gap === 'number' ? `${gap}px` : gap;

export const Row = ({
  children,
  rowGap,
  columnGap,
  mobileColumnGap,
  className
}: RowProps) => {
  return (
    <div
      className={`row ${className || ''}`}
      style={
        {
          '--row-gap': formatGap(rowGap),
          '--row-column-gap': formatGap(columnGap),
          '--row-mobile-column-gap': formatGap(mobileColumnGap)
        } as React.CSSProperties
      }
    >
      {children}
    </div>
  );
};

type ColProps = {
  children: React.ReactNode;
  span?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  className?: string;
};

export const Col = ({
  children,
  span,
  sm,
  md,
  lg,
  xl,
  className
}: ColProps) => {
  return (
    <div
      className={classNames(
        'col',
        span && `col-${span}`,
        sm && `col-sm-${sm}`,
        md && `col-md-${md}`,
        lg && `col-lg-${lg}`,
        xl && `col-xl-${xl}`,
        className
      )}
    >
      {children}
    </div>
  );
};
